import React from 'react';
import { connect } from 'react-redux';
import './Fax.css';

const DeliverySummary = ({ fax }) => {
  const { date, totalFaxes, success, failure } = fax;
  return (
    <tr>
      <td>{date}</td>
      <td>{totalFaxes}</td>
      <td>{success}</td>
      <td>{failure}</td>
    </tr>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(DeliverySummary);
